module.exports = __webpack_public_path__ + "static/media/upsell-benefit-ai.6c2fde1a.svg";